<template>
  <article class="">
<cabeceraEN></cabeceraEN>
     <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>Contact</h2>
    </section>
    <section class="descripcion">
      <div class="container">
        <div class="caja">
          <h2>Investor Relations</h2>
          <p><strong>José Luis Borrello</strong><br>
            Finance and Stategic Planning Manager<br><br>
            <a target="_blank" href="mailto:inversores@ciamega.com.ar ">inversores@ciamega.com.ar </a>
            </p>
        </div>
      </div>
      
    </section>
    <pieEN></pieEN>
  </article>
</template>

<script>
export default {
  name: 'contact',
  components: {
    CabeceraEN,
    PieEN
  }
}
import $ from 'jquery'
import CabeceraEN from '@/components/CabeceraEN'
import PieEN from '@/components/PieEN'
$(document).ready(function () {
  $('.btn').click(function () {
    $(this).toggleClass('active')
    $('.profile .box').toggleClass('open')
  })
})
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 50%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 28px
.btn-ar
    display: flex
    justify-content: center
    border: solid 1px #444
    margin-top: 30px
    width: 300px
    padding: 5px
    border-radius: 0px
    // &:hover
    // background-color: #004D9E
    &:hover
      background-color: #004D9E
      border-color: #fff
      a h5, i
        color: #fff
a h5, i 
  font-size: 18px
  margin: 0
  display: inline-block
  color: black
  &:hover
    color: #fff
p
  text-align: center
  padding-top: 20px
  font-size: 18px
  line-height: 20px
  a
    color: #004D9E
    font-size: 20px
.caja
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center

  /* Global Styles */





</style>



// WEBPACK FOOTER //
// src/components/contact-en/contact-en.vue